import { useNavigate } from 'react-router-dom';
import accountIcon from '../../../assets/accountIcon.svg';
import arrowLeft from '../../../assets/arrowLeft.svg';
import closeIcon from '../../../assets/closeIcon.svg';
import login from '../../../assets/login.svg';
import { ReactComponent as Loader } from '../../../assets/Spinner.svg';
import { useBrandContext } from '../../../context/BrandContext';

import './HeaderBasicLayout.css';
import BalanceManagement from '../balanceManagement/BalanceManagement';

export interface HeaderConfigComponentProps {
  headerText?: string;
  showLogo?: boolean;
  showActionButtons?: boolean;
  hasLoginInfo?: boolean;
  user?: any;
  backNavigation?: () => void;
  closeNavigation?: () => void;
}

const HeaderBasicLayout: React.FC<HeaderConfigComponentProps> = ({
  headerText = '',
  showLogo = true,
  showActionButtons = false,
  hasLoginInfo = false,
  user = {},
  backNavigation,
  closeNavigation,
}) => {
  const navigate = useNavigate();
  const brandContext = useBrandContext();

  const backToHome = () => navigate(`/${brandContext.brandName}/`);

  const goToLoginPage = () => navigate(`${brandContext.brandName}/login`);

  const goToUserProfilePage = () =>
    navigate(`${brandContext.brandName}/userProfile`);

  const formatName = (fullName: string) => {
    const regex = /^([a-zA-ZÀ-ÿ]+)\s([a-zA-ZÀ-ÿ])/;
    const match = fullName.match(regex);

    if (match) {
      const firstName = match[1];
      const lastNameInitial = match[2];
      return `${firstName} ${lastNameInitial}.`;
    }
    return fullName;
  };

  return (
    <div className='header-basic-layout-container'>
      {showLogo && (
        <div className='header-basic-layout-image-container'>
          {brandContext.appLogoFile ? (
            <img
              onClick={backToHome}
              loading='lazy'
              alt='brand-logo'
              src={brandContext.appLogoFile}
            />
          ) : (
            <Loader style={{ backgroundColor: 'transparent', height: 50 }} />
          )}
          {hasLoginInfo && (
            <>
              {!user?.name ? (
                <div className='login-section-home' onClick={goToLoginPage}>
                  <div className='login-text'>Faça o login</div>
                  <img
                    loading='lazy'
                    src={login}
                    className='login-icon'
                    alt=''
                  />
                </div>
              ) : (
                <>
                  <div
                    onClick={goToUserProfilePage}
                    className='login-section-home'
                  >
                    <img alt='login-user-icon' src={accountIcon} />
                    <span className='user-header-text'>
                      {formatName(user?.name || '')}
                    </span>
                  </div>
                </>
              )}
            </>
          )}
        </div>
      )}
      {headerText && (
        <div className='header-basic-layout-text-section'>
          <p>{headerText}</p>
        </div>
      )}
      {showActionButtons && (
        <div className='action-header-basic-layout-content'>
          <div onClick={backNavigation} className='arrow-left-icon-container'>
            <img
              className='style-arrow-left-icon'
              alt='arrow-left-icon'
              src={arrowLeft}
            />
          </div>
          <img onClick={closeNavigation} alt='close-icon' src={closeIcon} />
        </div>
      )}
      {hasLoginInfo && user?.name && <BalanceManagement user={user} />}
    </div>
  );
};

export default HeaderBasicLayout;
